import styled from "styled-components";
import RoundedCard from "../../components/RoundedCard";
import { flags } from "../../featureFlags";
import { routes } from "../../routes";

const ScrollableTabs = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 32px;
`;

const Annotate = () => {
  return (
    <ScrollableTabs>
      <RoundedCard
        title="Generate General Metadata"
        description="Upload a script and create a DataDesc compliant metadata sheet (general)"
        icon="../logo_code.svg"
        linkTo={routes.annotationGeneral.absolute}
        disable={!flags.annotationGeneral}
      />
      <RoundedCard
        title="Generate Technical Metadata"
        description="Upload a script and create a DataDesc compliant metadata sheet"
        icon="../logo_code.svg"
        linkTo={routes.annotationTechnical.absolute}
        disable={!flags.annotationTechnical}
      />
      <RoundedCard
        title="Merge Metadata"
        description="Merge general and technical metadata into one DataDesc sheet"
        icon="../logo_code.svg"
        linkTo={routes.mergeMetadata.absolute}
        disable={!flags.mergeMetadata}
      />
    </ScrollableTabs>
  );
};

export default Annotate;
